import React, { forwardRef } from 'react';

import { useMergeRefs } from '@floating-ui/react';

import { useTooltipContext } from './useTooltipContext';

import WpTooltipOverlay from './WpTooltipOverlay';

const WpTooltipContent = forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>(function TooltipContent(
  { children },
  propRef
) {
  const context = useTooltipContext();
  const ref = useMergeRefs([context.refs.setFloating, propRef]);

  if (!context.open) return null;

  return (
    <WpTooltipOverlay context={context} ref={ref}>
      {children}
    </WpTooltipOverlay>
  );
});

export default WpTooltipContent;
